// Prix par défaut (servent de valeurs de secours et de base dans l'admin).
// Les prix réels modifiables sont stockés dans Supabase (fichier config/pricing.json).
// Pour l'auto, un prix à 0 signifie "Sur devis".
export const DEFAULT_PRICING = {
  auto: {
    A: { exterieur: 50, interieur: 70, pack: 100, concession: 150 },
    B: { exterieur: 60, interieur: 80, pack: 120, concession: 170 },
    C: { exterieur: 70, interieur: 90, pack: 140, concession: 190 },
    D: { exterieur: 0, interieur: 0, pack: 0, concession: 0 },
    supplements: {
      shampooing_5_sieges: 20,
      shampooing_siege: 5,
      shampooing_sols: 20,
      poils: 5,
      tres_sale: 5,
    },
  },
  textile: {
    chaise_unite: 10,
    chaises_4: 30,
    fauteuil: 30,
    canape_2p: 40,
    canape_3p: 50,
    canape_45p: 70,
    canape_6p: 100,
    matelas_bebe: 20,
    matelas_1p: 40,
    matelas_2p: 50,
  },
  surfaces: {
    box_1p: 60,
    box_2p: 100,
    parking: 15,
    balcon: 5,
    terrasse: 5,
    cour: 4,
  },
};

// Fusion profonde simple : remplace les valeurs par défaut par celles trouvées en base.
export function mergePricing(base, override) {
  if (!override || typeof override !== "object") return base;
  const out = Array.isArray(base) ? [...base] : { ...base };
  for (const k of Object.keys(override)) {
    const ov = override[k];
    if (ov && typeof ov === "object" && !Array.isArray(ov) && base[k] && typeof base[k] === "object") {
      out[k] = mergePricing(base[k], ov);
    } else if (ov !== null && ov !== undefined && ov !== "") {
      out[k] = ov;
    }
  }
  return out;
}
